import React from "react"
import styled from "styled-components"
import Img from "gatsby-image"
import { Settings } from "../../../styles/theme"

const Boxstyled = styled.div`
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  transition: background 175ms ease-in-out;
  pointer-events: ${props => (props.toggle ? "all" : "none")};
  opacity: ${props => (props.toggle ? 1 : 0)} !important;
  z-index: 999;
  > div {
    .bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: ${props =>
        props.toggle ? "rgba(0, 0, 0, 0.8)" : "rgba(0, 0, 0, 0)"};
    }
    > div {
      position: absolute !important;
      padding: 4rem 2rem;
      height: 70vh;
      background: #fff;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 80vw;
      transition: opacity 175ms ease-in-out;
      display: block;
      .close {
        font-weight: 700;
        color: ${Settings.secondaryColor};
        position: absolute;
        right: 2rem;
        top: 1rem;
      }
      .gatsby-image-wrapper {
        height: 100%;
      }
    }
  }
  .prev-arrow,
  .next-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    color: #fff;
    z-index: 999;
    cursor: pointer;
    font-weight: 700;
    font-size: 1.5rem;
  }
  .prev-arrow {
    left: 2%;
  }
  .next-arrow {
    right: 2%;
  }
`

export const Box = ({
  fluid,
  toggle,
  toggleLightbox,
  next,
  prev,
  setSelected,
}) => (
  <Boxstyled toggle={toggle}>
    {prev || prev === 0 ? (
      <span onClick={() => setSelected(prev)} className="prev-arrow">
        {"<"}
      </span>
    ) : (
      ""
    )}
    <div>
      <span className="bg" onClick={toggleLightbox} />
      <div>
        <div className="close" onClick={toggleLightbox}>
          X
        </div>
        <Img fluid={fluid} />
      </div>
    </div>
    {next ? (
      <span onClick={() => setSelected(next)} className="next-arrow">
        {">"}
      </span>
    ) : (
      ""
    )}
  </Boxstyled>
)
